import React from 'react';
import UserLimitPanel from './StatsHeaderPanels/UserLimitPanel';
import AdminCountPanel from './StatsHeaderPanels/AdminCountPanel';

import IconButton from '@mui/material/IconButton';
import FilterListIcon from '@mui/icons-material/FilterList';
import { Badge } from '@mui/material';

type statChangeType = {
  statsChanged: boolean;
  onOpenFilters: (event: React.MouseEvent<HTMLElement>) => void;
  activeFilterCount?: number;
};

const UserStatsHeader = ({ statsChanged, onOpenFilters, activeFilterCount }: statChangeType) => {
  return (
    <div
      className="user-stats-header"
      style={{ display: 'flex', alignItems: 'center', gap: '16px' }}
    >
      <UserLimitPanel statsChanged={statsChanged} />
      <AdminCountPanel statsChanged={statsChanged} />

      <div style={{ marginLeft: 'auto', marginRight: '16px' }}>
        <Badge badgeContent={activeFilterCount} color="secondary">
          <IconButton onClick={onOpenFilters} aria-label="filter users">
            <FilterListIcon />
          </IconButton>
        </Badge>
      </div>
    </div>
  );
};

export default UserStatsHeader;
